import classNames from "classnames/bind";
import { FeaturesSpecsSelectedTab } from "features/vehicleDetails/modals/FeaturesSpecs";

import styles from "./VehicleDetails.module.scss";
import CarFeatures, { CarFeaturesProps } from "./components/CarFeatures";
import CarSpecs, { CarSpecsProps } from "./components/CarSpecs";
import { IncludedExtras, IncludedExtrasProps } from "./components/IncludedExtras";
import QualityWidget, { QualityWidgetProps } from "./components/QualityWidget";

const cx = classNames.bind(styles);

export type VehicleDetailsProps = {
    components: {
        carSpecs: CarSpecsProps;
        carFeatures: CarFeaturesProps;
        includedExtras: IncludedExtrasProps;
        qualityWidget: QualityWidgetProps;
    };
};

export const VehicleDetails = ({
    components,
    handleOpenFeaturesSpecsModal,
}: VehicleDetailsProps & {
    handleOpenFeaturesSpecsModal: (
        selectedRow?: string,
        selectedTab?: FeaturesSpecsSelectedTab
    ) => any;
}) => {
    const { carSpecs, carFeatures, includedExtras, qualityWidget } = components;

    return (
        <div className={cx("vehicleDetails")}>
            <div className={cx("col", "colFirst")}>
                {!!includedExtras?.extras?.length ? (
                    <IncludedExtras {...includedExtras} isInsideModal={false} />
                ) : (
                    <QualityWidget {...qualityWidget} />
                )}
            </div>
            <div className={cx("col", "colMiddle", { noExtras: !includedExtras?.extras?.length })}>
                <CarSpecs
                    {...carSpecs}
                    handleOpenFeaturesSpecsModal={handleOpenFeaturesSpecsModal}
                />
            </div>
            <div className={cx("col", "colLast")}>
                <CarFeatures
                    {...carFeatures}
                    handleOpenFeaturesSpecsModal={handleOpenFeaturesSpecsModal}
                />
            </div>
        </div>
    );
};
